import { action } from 'satcheljs';
/**
 * Dispatched in the constructor of MailSearchBoxContainer component, with the
 * intention of handling any initialization that needs to happen before component
 * renders.
 */
export var onMailSearchBoxContainerInitialized = action('ON_MAILSEARCHBOXCONTAINER_INITIALIZED');
/**
 * Dispatched when MailSearchBoxContainer is notified that OWA has resized.
 */
export var onOwaResized = action('ON_OWA_RESIZED');
//# sourceMappingURL=bootActions.js.map